module["exports"] = [
  "###-###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/address/postcode.js
// module id = 971
// module chunks = 0